<router-outlet />
<app-cookie-consent />
